import { render, staticRenderFns } from "./pageLocation.vue?vue&type=template&id=1a9e67c9&scoped=true&"
import script from "./pageLocation.vue?vue&type=script&lang=js&"
export * from "./pageLocation.vue?vue&type=script&lang=js&"
import style0 from "./pageLocation.vue?vue&type=style&index=0&id=1a9e67c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9e67c9",
  null
  
)

export default component.exports